/* Email Signup — Newsletter form submission */
(function() {
  'use strict';

  var form = document.querySelector('[data-email-signup]');
  if (!form) return;

  var successEl = document.querySelector('[data-signup-success]');

  form.addEventListener('submit', function(e) {
    e.preventDefault();

    var email = form.querySelector('input[type="email"]').value;
    if (!email) return;

    var formData = new FormData(form);

    fetch(form.action, {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    })
    .then(function() {
      form.style.display = 'none';
      if (successEl) successEl.style.display = 'block';
    })
    .catch(function() {
      /* Submit normally on error */
      form.removeEventListener('submit', arguments.callee);
      form.submit();
    });
  });
})();
